// Components
import cx from "classnames";

import { ConferenceSessionsSession } from "./ConferenceSessionsSession";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conference.module.scss";

export const ConferenceSessions = (props) => {
    const { conference } = props;
    const { region, is_featured } = conference || {};

    function renderSessions() {
        return conference?.sessions?.map((session, i) => {
            return <ConferenceSessionsSession key={i} session={session} />;
        });
    }

    return (
        <Section classes={styles.sessions} id="agenda">
            <h1>agenda</h1>
            <div className={styles.subheader}>
                <span>All times are in {region}</span>
            </div>
            <div className={cx(styles.footnote, {
                    [styles["footnote--hidden"]]:
                        !is_featured,
                })}
            >
                * Agenda subject to change
            </div>
            {renderSessions()}
        </Section>
    );
};
